import type {
  AssetsSelectParentOptionItemData,
  AssetsSelectParentOptionItemValue,
  AssetsSelectParentProps,
} from "./assets-select-parent.type";

import { useTranslation } from "react-i18next";

import { filterAncestorsSelfAndChildren } from "@/entities/ancestor";
import { ASSETS_FILTERS } from "@/entities/assets";
import QueryableSelect from "@/modules/queryable-select";

import AssetsSelectParentOption from "./assets-select-parent-option";

const AssetsSelectParent = ({
  currentAssetId,
  selectedLocation,
  ...props
}: AssetsSelectParentProps) => {
  const { t } = useTranslation();
  const label = t("global:asset");

  return (
    <QueryableSelect<
      AssetsSelectParentOptionItemValue,
      AssetsSelectParentOptionItemData
    >
      withContext
      dataTestId="assets-select-parent"
      name="asset"
      model="assets"
      filterBy="name"
      label={label}
      placeholder={label}
      optionFormat={AssetsSelectParentOption}
      filterCallback={
        currentAssetId
          ? (option) =>
              filterAncestorsSelfAndChildren({
                ancestors: option.ancestors,
                itemType: "asset",
                itemId: currentAssetId,
              })
          : undefined
      }
      additionalFilters={
        selectedLocation
          ? { [ASSETS_FILTERS.LOCATION_ID]: selectedLocation }
          : undefined
      }
      disabled={!selectedLocation}
      {...props}
    />
  );
};

export default AssetsSelectParent;
